import {useEffect, useState} from 'react';
import blogDao from '../../dao/blogDao';

const EMPTY = [];

export default function useDeadLinkLists() {
  const [deadLinkLists, setDeadLinkLists] = useState(() =>
    blogDao.peekDeadLinkBlackLists()
  );

  useEffect(() => {
    if (deadLinkLists) return;
    let active = true;
    blogDao.listDeadLinkBlackLists().then(domains => {
      if (active) setDeadLinkLists(domains);
    });
    return () => {
      active = false;
    };
  }, []);

  return {deadLinkLists: deadLinkLists || EMPTY, loading: !deadLinkLists};
}
